import NoData from "@/components/ui/no-data";

export const FaqsHistory = () => {
  return (
    <div className="mt-24">
      <NoData
        title="No hay historial disponible"
        description="No se han registrado cambios o actividades recientes en las preguntas frecuentes."
      />
    </div>
  );
};
